import { useRef, useEffect } from 'react';
import { EditorView } from '@codemirror/view';
import { EditorState } from '@codemirror/state';
import { python } from '@codemirror/lang-python';
import { oneDark } from '@codemirror/theme-one-dark';

/**
 * Только чтение, подсветка Python (CodeMirror 6).
 */
export default function ReadOnlyPythonCode({ value, className = '' }) {
  const hostRef = useRef(null);

  useEffect(() => {
    const parent = hostRef.current;
    if (!parent) return undefined;
    const doc = value ?? '';
    const state = EditorState.create({
      doc,
      extensions: [
        python(),
        oneDark,
        EditorView.editable.of(false),
        EditorState.readOnly.of(true),
        EditorView.lineWrapping,
      ],
    });
    const view = new EditorView({ state, parent });
    return () => {
      view.destroy();
    };
  }, [value]);

  return <div ref={hostRef} className={`read-only-python-cm ${className}`.trim()} />;
}
